import {
    BulletinListExportPdfRequest
} from '../../../../../../../infrastructure/remote/sacmi/dto/request/BulletinListExportPdfRequest';
import {BulletinListFilters} from '../../../../../view/useBulletinListFilters';

const ExportBulletinListPdfDataMapper = {
    fromDomain(bulletinIds: string[], filters: BulletinListFilters): BulletinListExportPdfRequest {
        return {bulletin_ids: bulletinIds, ...filters};
    }
}

export default ExportBulletinListPdfDataMapper;
